import Heading from './Heading.vue';

export default Heading;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/forms/components/heading/index.ts